module.exports = __webpack_public_path__ + "img/PHP.4b79daed.png";